import React from 'react';
import HelmetBuilder from '../components/helmet-builder';


class PageNotFound extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const header = document.getElementsByClassName('header')[0];
    if (header) {
      header.classList.add('header__black');
    }
  }

  render() {
    return (
      <div className="terms">
        <HelmetBuilder
          data={{ title: "Page Not Found - The Farm Project" }}
        />
        <br/>
        <br/>
        <br/>
        <h1 style={{textAlign: 'center'}}>
          Oops! That page can't be found.
        </h1>
        <br/>
        <br/>
      </div>
    );
  }
}

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/pages/404.js